import { useState, useContext, useEffect } from "react"

import { graphql, useStaticQuery } from "gatsby"
import { I18nextContext } from "gatsby-plugin-react-i18next"

import { LocaleData } from "types/gatsby-alias"
import { isBrowser } from "utils/functions"

export default function useGetStaticTranslations(
  nameSpace: string,
  locale?: string
) {
  const [translationValue, setTranslationValue] = useState({})
  const context = useContext(I18nextContext)

  const translations: Queries.LocaleTranslationsQuery = useStaticQuery(graphql`
    query LocaleTranslations {
      allLocale {
        nodes {
          ns
          language
          data
        }
      }
    }
  `)

  useEffect(() => {
    if (isBrowser()) {
      const searchLanguage = locale ?? context.language
      const queryNameSpace = translations.allLocale.nodes.find(
        node => node.language === searchLanguage && node.ns === nameSpace
      )
      if (!queryNameSpace) return
      const { data: localeData } = queryNameSpace
      if (localeData) {
        const localeDataJS: LocaleData = JSON.parse(localeData) as LocaleData
        setTranslationValue(localeDataJS)
      }
    }
  }, [translations, context, locale, nameSpace])

  return translationValue
}
